// extracted by mini-css-extract-plugin
export default {"addPositionsButton":"CreateEditGroup_addPositionsButton__1zeP-","infoNote":"CreateEditGroup_infoNote__e0yDO"};